import { Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StepDescriptionBox from './StepDescriptionBox';
import './InitialStep.css';
import { fadingClassName } from '../../../../../shared/utils/commons';
import { useEffect, useState } from 'react';
import useDebounce from '../../../../../shared/hooks/useDebounce';
import InfoDialog from '../../../../../components/InfoDialog/InfoDialog';
import { IframeContent } from '../../../../../components/IframeContent/IframeContent';
import SelectModeDialog from '../../../../../components/SelectModeDialog/SelectModeDialog';
import { useAppDispatch } from '../../../../../shared/redux/store';
import { resetSourceActivities, resetSourceSyllabuses} from '../../../requestSlice';
import { useAppContext } from '../../../../App.Context';
import { useRequestdata } from '../../../useRequestData';
import { useRequestContext } from '../../../Request.Context';

interface InitialStepProps {
  beginRequest: () => void
}

const InitialStep: React.FC<InitialStepProps> = ({ beginRequest }) => {
  const [leave, setLeave] = useState(false);
  const [debouncedLeave, isLeaving] = useDebounce(leave, 100);
  const [openTutorialDialog, setOpenTutorialDialog] = useState(false);
  const [openSelectModeDialog, setOpenSelectModeDialog] = useState(false);
  const dispatch = useAppDispatch();
  const { setRequestType} = useAppContext();
  const {setSourceInstitution} = useRequestdata({})
  const { setTermsAndConditionsChecked } = useRequestContext();

  const { t } = useTranslation();

  useEffect(() => {
    debouncedLeave && beginRequest();
  }, [debouncedLeave]);

  useEffect(() => {
    dispatch(resetSourceSyllabuses());
    dispatch(resetSourceActivities());
    setSourceInstitution(null)
    setRequestType('undefined')
    setTermsAndConditionsChecked(false)
  }, []);

  return (
    <Grid className={`InitialStep-Container ${fadingClassName(leave && isLeaving)}`}>
      <Typography
        color="primary"
        className="InitialStep-Title"
      >
        <>{t('titleInitialStep')}</>
      </Typography>
      <Typography className="InitialStep-Subtitle">
        <>{t('stepsDescription')}</>
      </Typography>
      <div className="InitialStep-StepsBox">
        <StepDescriptionBox step={1}>
          <>
          <Typography variant="subtitle1" fontWeight="bold">{t('CompleteInformation')}</Typography>
          <Typography variant="body2" color="#949494">{t('PersonalContactsDetails')}</Typography>
          </>
        </StepDescriptionBox> 
        <StepDescriptionBox step={2}>
          <>
          <Typography variant="subtitle1" fontWeight="bold">{t('SimulatedEquivalencies')}</Typography>
          <Typography variant="body2" color="#949494">{t('AccessSimulator')}</Typography>
          </>
        </StepDescriptionBox>
        <StepDescriptionBox step={3}>
          <>
          <Typography variant="subtitle1" fontWeight="bold">{t('StartProcess')}</Typography>
          <Typography variant="body2" color="#949494">{t('UploadDocuments')}</Typography>
          </>
        </StepDescriptionBox>
        
      </div>
      <Grid container justifyContent="flex-end" className='REQXXI-InitialStep-ButtonGrid'>
        <Button
          fullWidth
          id="initialStep-beginRequest"
          data-testid="initialStep-beginRequest"
          variant="contained"
          className='REQXXI-BeginRequest-Button'
          onClick={() => setOpenSelectModeDialog(true)}
        ><>{t('start')}</></Button>
      </Grid>
      <InfoDialog
        open={openTutorialDialog}
        title={t('infotitle')}
        content={<IframeContent />}
        onClose={() => {
          setOpenTutorialDialog(false)
        }}
        size='lg'
      />

      <SelectModeDialog
        open={openSelectModeDialog}
        title={t('selectModeTitle')}
        setLeave={setLeave}
        onClose={() => {
          setOpenSelectModeDialog(false)
        }}
        size='sm'
      />
    </Grid>
  );
};

export default InitialStep;